/**
 * Created by neo on 16.10.21.
 */
import { makeAutoObservable } from 'mobx';

export type HealthDataPointAnalyticsResultEntry = {
  type: string;
  value: number;
  count: number;
};

export function createHealthDataPointAnalyticsResultEntry(
  json?: Partial<HealthDataPointAnalyticsResultEntry>,
): HealthDataPointAnalyticsResultEntry {
  return makeAutoObservable({
    type: json?.type ?? '',
    value: json?.value ?? 0,
    count: json?.count ?? 0,
  });
}
